import api from 'shared/api'

const FETCH_REQUEST = 'nfpExecutives/FETCH_REQUEST';
const FETCH_SUCCESS = 'nfpExecutives/FETCH_SUCCESS';
const FETCH_NFP_SUCCESS = 'nfpExecutives/FETCH_NFP_SUCCESS';
const FETCH_FAILURE = 'nfpExecutives/FETCH_FAILURE';

const initialState = {
  nfps: [],
  total_size: 0,
  loadedNfps: [],
  loadedIds: [],
  loaded: false,
  loading: false,
  errors: []
};

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchNfpSuccess(payload) {
  return {
    type: FETCH_NFP_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadNfp(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const loadedIds = state.nfps.loadedIds ? state.nfps.loadedIds.slice() : [];
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchRequest({ loadedIds }));

    return api(`api/v1/nfps/${id}`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchNfpSuccess(json))
      })
      .catch((json) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(json.errors))
        })
      });
  }
}

export function loadNfps(options = {}) {
  return (dispatch) => {
    dispatch(fetchRequest());

    return api('api/v1/nfps', options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      });
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      });
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        total_size: payload.total_size,
        nfps: [...payload.result]
      });
    case FETCH_NFP_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        errors: [],
        loadedNfps: [
          ...state.loadedNfps,
          payload
        ]
      });
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      });
    default:
      return state
  }
}

